/* Carlotta Milano - progressive collection infinite scroll */
(function () {
  'use strict';

  if (window.StoreInfiniteScroll && window.StoreInfiniteScroll.version) return;

  const SELECTORS = {
    section: '[data-section-type="collection"]',
    productsContainer: '[data-products-grid]',
    grid: '#CollectionLoop',
    productCard: '.product-item[data-grid-item]',
    pagination: '.pagination-custom',
    next: '.pagination-custom__next[href]'
  };

  const CLASS = {
    paginationHidden: 'store-infinite-scroll__pagination-hidden',
    status: 'store-infinite-scroll__status',
    sentinel: 'store-infinite-scroll__sentinel',
    retry: 'store-infinite-scroll__retry'
  };

  const TEXT = {
    loading: 'Caricamento di altri prodotti…',
    loaded: 'Altri prodotti caricati.',
    end: 'Tutti i prodotti sono stati visualizzati.',
    error: 'Impossibile caricare altri prodotti.',
    retry: 'Riprova'
  };

  const state = {
    section: null,
    container: null,
    grid: null,
    pagination: null,
    sentinel: null,
    status: null,
    observer: null,
    gridObserver: null,
    controller: null,
    loading: false,
    stopped: false,
    generation: 0,
    nextUrl: null,
    loadedUrls: new Set(),
    productKeys: new Set(),
    retries: new Map()
  };

  function addStyles() {
    if (document.getElementById('StoreInfiniteScrollStyles')) return;
    const style = document.createElement('style');
    style.id = 'StoreInfiniteScrollStyles';
    style.textContent = `
      .${CLASS.paginationHidden}{display:none!important}
      .${CLASS.status}{min-height:1.5em;margin:20px 0;text-align:center;font-size:.875rem}
      .${CLASS.status}[data-state="idle"]{min-height:0;margin:0}
      .${CLASS.sentinel}{width:100%;height:1px;pointer-events:none}
      .${CLASS.retry}{appearance:none;border:0;background:transparent;text-decoration:underline;cursor:pointer;font:inherit;padding:6px 10px}
      @media (prefers-reduced-motion: reduce){.${CLASS.status} *{animation:none!important;transition:none!important}}
    `;
    document.head.appendChild(style);
  }

  function normalizedUrl(href) {
    if (!href) return null;
    try {
      const url = new URL(href, window.location.href);
      if (url.origin !== window.location.origin) return null;
      return url.href;
    } catch (_) {
      return null;
    }
  }

  function productKey(card) {
    const quickAdd = card.querySelector('[data-quick-add-holder]');
    if (quickAdd && quickAdd.getAttribute('data-quick-add-holder')) {
      return `id:${quickAdd.getAttribute('data-quick-add-holder')}`;
    }

    const idMatch = (card.id || '').match(/-(\d+)$/);
    if (idMatch) return `id:${idMatch[1]}`;

    const link = card.querySelector('[data-product-link]');
    const href = link && link.getAttribute('href');
    if (href) {
      try {
        const url = new URL(href, window.location.origin);
        return `url:${url.pathname}`;
      } catch (_) {}
    }

    return card.id ? `node:${card.id}` : null;
  }

  function collectExistingKeys() {
    state.productKeys.clear();
    if (!state.grid) return;
    state.grid.querySelectorAll(SELECTORS.productCard).forEach((card) => {
      const key = productKey(card);
      if (key) state.productKeys.add(key);
    });
  }

  function setPaginationVisibility(hidden) {
    if (!state.pagination) return;
    state.pagination.classList.toggle(CLASS.paginationHidden, hidden);
    if (hidden) state.pagination.setAttribute('aria-hidden', 'true');
    else state.pagination.removeAttribute('aria-hidden');
  }

  function setStatus(type, message, withRetry) {
    if (!state.status) return;
    state.status.dataset.state = type;
    state.status.replaceChildren();

    if (message) {
      const span = document.createElement('span');
      span.textContent = message;
      state.status.appendChild(span);
    }

    if (withRetry) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = CLASS.retry;
      button.textContent = TEXT.retry;
      button.addEventListener('click', () => {
        setPaginationVisibility(true);
        setStatus('idle', '', false);
        observeSentinel();
        loadNextPage();
      }, { once: true });
      state.status.appendChild(document.createTextNode(' '));
      state.status.appendChild(button);
    }
  }

  function abortActiveRequest() {
    if (state.controller) {
      state.controller.abort();
      state.controller = null;
    }
    state.loading = false;
  }

  function disconnectIntersection() {
    if (state.observer) {
      state.observer.disconnect();
      state.observer = null;
    }
  }

  function stop(reason) {
    state.stopped = true;
    abortActiveRequest();
    disconnectIntersection();
    if (state.sentinel) state.sentinel.remove();
    state.sentinel = null;
    if (reason === 'end') setStatus('end', TEXT.end, false);
  }

  function currentNextUrl(root) {
    const next = root && root.querySelector(SELECTORS.next);
    return normalizedUrl(next && next.getAttribute('href'));
  }

  function syncPaginationFrom(parsedContainer) {
    const incoming = parsedContainer && parsedContainer.querySelector(SELECTORS.pagination);
    if (!state.pagination) return;

    if (incoming) {
      state.pagination.innerHTML = incoming.innerHTML;
      setPaginationVisibility(true);
    } else {
      state.pagination.innerHTML = '';
      setPaginationVisibility(true);
    }
  }

  function prepareCard(card) {
    card.querySelectorAll('img').forEach((img) => {
      img.loading = 'lazy';
      img.decoding = 'async';
      img.setAttribute('fetchpriority', 'low');
      img.removeAttribute('preload');
    });

    // Broadcast's initial AOS pass has already run; keep appended cards visible
    // without re-running global theme initializers or duplicating listeners.
    card.querySelectorAll('[data-aos]').forEach((el) => el.classList.add('aos-animate'));
    if (card.hasAttribute('data-aos')) card.classList.add('aos-animate');
  }

  function appendCards(incomingGrid) {
    const fragment = document.createDocumentFragment();
    let inserted = 0;

    incomingGrid.querySelectorAll(SELECTORS.productCard).forEach((card) => {
      const key = productKey(card);
      if (key && state.productKeys.has(key)) return;
      if (key) state.productKeys.add(key);

      prepareCard(card);
      fragment.appendChild(card);
      inserted += 1;
    });

    if (inserted > 0) state.grid.appendChild(fragment);
    return inserted;
  }

  function observeSentinel() {
    if (state.stopped || !state.sentinel || !state.nextUrl) return;
    disconnectIntersection();
    state.observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) loadNextPage();
    }, { root: null, rootMargin: '1000px 0px', threshold: 0.01 });
    state.observer.observe(state.sentinel);
  }

  async function loadNextPage() {
    if (state.loading || state.stopped || !state.nextUrl) return;

    const requestUrl = normalizedUrl(state.nextUrl);
    if (!requestUrl || state.loadedUrls.has(requestUrl)) {
      stop('end');
      return;
    }

    const requestGeneration = state.generation;
    const requestContext = `${window.location.pathname}${window.location.search}`;
    state.loading = true;
    disconnectIntersection();
    state.controller = new AbortController();
    setStatus('loading', TEXT.loading, false);

    try {
      const response = await fetch(requestUrl, {
        method: 'GET',
        credentials: 'same-origin',
        signal: state.controller.signal,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });

      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const html = await response.text();

      if (requestGeneration !== state.generation || requestContext !== `${window.location.pathname}${window.location.search}`) return;

      const doc = new DOMParser().parseFromString(html, 'text/html');
      const incomingContainer = doc.querySelector(SELECTORS.productsContainer);
      const incomingGrid = incomingContainer && incomingContainer.querySelector(SELECTORS.grid);
      if (!incomingContainer || !incomingGrid) throw new Error('Invalid collection grid response');

      const incomingCards = incomingGrid.querySelectorAll(SELECTORS.productCard);
      if (!incomingCards.length) throw new Error('Collection page returned no product cards');

      const inserted = appendCards(incomingGrid);
      if (!inserted) throw new Error('No new product cards found');

      state.loadedUrls.add(requestUrl);
      state.retries.delete(requestUrl);
      syncPaginationFrom(incomingContainer);
      state.nextUrl = currentNextUrl(incomingContainer);

      if (state.nextUrl && state.loadedUrls.has(state.nextUrl)) {
        throw new Error('Pagination cycle detected');
      }

      if (!state.nextUrl) {
        stop('end');
        return;
      }

      setStatus('loaded', TEXT.loaded, false);
      observeSentinel();
    } catch (error) {
      if (error && error.name === 'AbortError') return;
      console.error('[StoreInfiniteScroll]', error);

      const attempts = (state.retries.get(requestUrl) || 0) + 1;
      state.retries.set(requestUrl, attempts);
      setPaginationVisibility(false);
      setStatus('error', TEXT.error, attempts <= 2);
      disconnectIntersection();
    } finally {
      if (requestGeneration === state.generation) {
        state.loading = false;
        state.controller = null;
      }
    }
  }

  function createUi() {
    if (!state.container || !state.grid) return false;

    state.container.querySelectorAll(`.${CLASS.sentinel}, .${CLASS.status}`).forEach((node) => node.remove());

    state.status = document.createElement('div');
    state.status.className = CLASS.status;
    state.status.dataset.state = 'idle';
    state.status.setAttribute('role', 'status');
    state.status.setAttribute('aria-live', 'polite');
    state.status.setAttribute('aria-atomic', 'true');

    state.sentinel = document.createElement('div');
    state.sentinel.className = CLASS.sentinel;
    state.sentinel.setAttribute('aria-hidden', 'true');

    state.container.appendChild(state.sentinel);
    state.container.appendChild(state.status);
    return true;
  }

  function bindGridReplacementObserver() {
    if (state.gridObserver) state.gridObserver.disconnect();
    if (!state.container) return;

    state.gridObserver = new MutationObserver(() => {
      const currentGrid = state.container.querySelector(SELECTORS.grid);
      if (!state.grid || !state.grid.isConnected || currentGrid !== state.grid) {
        restart();
      }
    });

    state.gridObserver.observe(state.container, { childList: true, subtree: true });
  }

  function restart() {
    state.generation += 1;
    abortActiveRequest();
    disconnectIntersection();

    const section = document.querySelector(SELECTORS.section);
    const container = section && section.querySelector(SELECTORS.productsContainer);
    const grid = container && container.querySelector(SELECTORS.grid);

    state.section = section;
    state.container = container;
    state.grid = grid;
    state.pagination = container && container.querySelector(SELECTORS.pagination);
    state.loadedUrls.clear();
    state.retries.clear();
    state.stopped = false;

    if (!section || !container || !grid) return;

    collectExistingKeys();
    state.nextUrl = currentNextUrl(container);
    createUi();
    bindGridReplacementObserver();

    if (!state.nextUrl) {
      setPaginationVisibility(false);
      stop('end');
      return;
    }

    setPaginationVisibility(true);
    observeSentinel();
  }

  function destroy() {
    state.generation += 1;
    abortActiveRequest();
    disconnectIntersection();
    if (state.gridObserver) state.gridObserver.disconnect();
    state.gridObserver = null;
    if (state.sentinel) state.sentinel.remove();
    if (state.status) state.status.remove();
    setPaginationVisibility(false);
  }

  window.StoreInfiniteScroll = {
    version: '1.0.0',
    restart,
    destroy
  };

  addStyles();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', restart, { once: true });
  else restart();
})();
